export const GET_MAP_FACILITY_PENDING = "GET_MAP_FACILITY_PENDING";
export const GET_MORE_MAP_FACILITY_PENDING = "GET_MORE_MAP_FACILITY_PENDING";
export const GET_MAP_FACILITY_SUCCESS = "GET_MAP_FACILITY_SUCCESS";
export const GET_MORE_MAP_FACILITY_SUCCESS = "GET_MORE_MAP_FACILITY_SUCCESS";
export const RESET_MAP_FACILITY = "RESET_MAP_FACILITY";
